// Shopify Buy Button Configuration
// Connected to Cotton Candy Girl Shopify Store

export const SHOPIFY_CONFIG = {
  domain: process.env.REACT_APP_SHOPIFY_DOMAIN || "deas1q-dx.myshopify.com",
  storefrontAccessToken: process.env.REACT_APP_SHOPIFY_TOKEN || "f83d345a50dc5c79962044a4b3dbe571",
  enabled: true,
};

// Initialize Shopify Buy SDK
let shopifyClient = null;

export const getShopifyClient = async () => {
  if (shopifyClient) return shopifyClient;
  
  // Load Shopify Buy SDK
  if (!window.ShopifyBuy) {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  
  shopifyClient = window.ShopifyBuy.buildClient({
    domain: SHOPIFY_CONFIG.domain,
    storefrontAccessToken: SHOPIFY_CONFIG.storefrontAccessToken,
  });
  
  return shopifyClient;
};

// Search for a product by title and add to cart
export const addToCartAndCheckout = async (productTitle) => {
  if (!SHOPIFY_CONFIG.enabled) {
    return { success: false, message: "coming_soon" };
  }
  
  try {
    const client = await getShopifyClient();
    
    // Fetch all products
    const products = await client.product.fetchAll(50);
    
    // Find the matching product (case-insensitive partial match)
    const searchTitle = productTitle.toLowerCase().replace(/\s+/g, '');
    const product = products.find(p => {
      const pTitle = p.title.toLowerCase().replace(/\s+/g, '');
      return pTitle.includes(searchTitle) || searchTitle.includes(pTitle);
    });
    
    if (!product) {
      console.log('Product not found:', productTitle);
      console.log('Available products:', products.map(p => p.title));
      return { success: false, message: "product_not_found" };
    }
    
    // Get the first variant
    const variantId = product.variants[0].id;
    
    // Create checkout and add item
    const checkout = await client.checkout.create();
    await client.checkout.addLineItems(checkout.id, [{
      variantId: variantId,
      quantity: 1,
    }]);
    
    // Redirect to Shopify checkout
    window.location.href = checkout.webUrl;
    return { success: true };
    
  } catch (error) {
    console.error('Shopify checkout error:', error);
    return { success: false, message: "checkout_error" };
  }
};

// Fetch all products from Shopify
export const fetchAllProducts = async () => {
  try {
    const client = await getShopifyClient();
    const products = await client.product.fetchAll(50);
    return products;
  } catch (error) {
    console.error('Error fetching products:', error);
    return [];
  }
};
